<div class="flex gap-1 items-center">
  <button
    [matMenuTriggerFor]="descriptionMenu"
    [attr.aria-label]="'task-activity-description-changed-view-full' | translate"
    type="button"
    class="inline-block max-w-full cursor-pointer border-0 bg-transparent p-0 text-left font-inherit text-proffeo-muted text-sm hover:underline break-words whitespace-normal"
  >
    {{ 'task-activity-description-changed' | translate }}: {{ descriptionPlainText() }}
  </button>
  <mat-menu #descriptionMenu="matMenu">
    <div
      [innerHTML]="$safeNavigationMigration(activity()?.data?.to)"
      class="w-full max-h-[50vh] overflow-auto p-4 text-sm text-proffeo-text"
    ></div>
  </mat-menu>
</div>
